import React from 'react';

const UnassignedView = () => {
    return(
        <div style={{textAlign: 'center'}}>
            <h1 style={{marginTop:100, color: 'black'}}>Usuário não atribuido!</h1>
            <p>Contate o supporte para que seu usuário seja corretamente atribuido!</p>
        </div>
    )}

export default UnassignedView;